import { useQuery } from '@tanstack/react-query';
import { adminApi } from '../api/adminApi';
import { adminKeys } from '../api/adminQueryKeys';
export function useAdminUserMessages(userId, page, pageSize = 50) {
    return useQuery({
        queryKey: adminKeys.userMessages(userId, page),
        queryFn: () => adminApi.getUserMessages(userId, page, pageSize),
    });
}
